<template>
    <div class="explanation-container">
        <div>
            <h3 class="text-h5 text-left mb-3">{{ customer_data.first_name }} responded!</h3>
            <div class="explanation-points">
                <div
                    class="explanation-point"
                    v-for="(point, idx) in explanationPoints"
                    :key="idx"
                >
                    <v-icon
                        color="primary"
                        size="28"
                        class="point-icon"
                        aria-hidden="true"
                    >
                        mdi-chevron-right
                    </v-icon>
                    <p class="point-text">{{ point }}</p>
                </div>
            </div>
        </div>

        <v-btn
            color="primary"
            elevation="0"
            @click="$emit('reset')"
        >
            <v-icon
                size="18"
                aria-hidden="true"
                left
            >
                mdi-restart
            </v-icon>
            Restart Demo
        </v-btn>
    </div>
</template>

<script>
export default {
    name: 'ExplainerCustomerResponse',

    props: {
        customer_data: {
            type: Object,
            required: true
        },
        wine_data: {
            type: Object,
            required: true
        }
    },

    computed: {
        explanationPoints() {
            return [
                `She responded to indicate interest in the new wine release`,
                `Using RedChirp, Barrel Creek Vineyards staff can track and respond to her inquiry in real-time`
            ];
        }
    }
}
</script>

<style lang="scss" scoped>
.explanation-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2rem;
    align-items: center;
    padding: 2rem;

    @media (max-width: 900px) {
        padding: .5rem 0;
    }
}
</style>
